export default __webpack_public_path__ + "sounds/cb06a4db0c0759d9b90b881b6d829514.mp3";